var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Listado de Pedidos","title-color":"primary"}},[_c('div',{staticClass:"mt-3"},[_c('listado_pedidosVue',{attrs:{"periodoSelect":_vm.periodoSelect,"pedidos":_vm.pedidos},on:{"changeRecarge":_vm.changeHandleRecarga}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }